import React from 'react';
import { useTranslation } from 'react-i18next';
import './AboutUs.css'; // Import styles
import founderPhoto from '../assets/images/founder.jpg';
import co_founderPhoto from '../assets/images/co-founder.jpg';

function AboutUs() {
  const { t } = useTranslation();

  return (
    <div className="about-us-page"> {/* Renamed for clarity, avoiding conflict if a global .about-us exists */}
      
      {/* This main content wrapper will be our flex container for side-by-side sections */}
      <div className="about-us-content-wrapper">
        <div className="team-section">
          <div className="founder-card"> {/* Using a card for individual team members */}
            <img src={founderPhoto} alt={t('about_us.founder_name_alt_text')} className="team-photo" />
            <p className="team-name">{t('about_us.founder_name')}</p>
            <p className="team-title">{t('about_us.founder_title')}</p>
          </div>

          <div className="cofounder-card"> {/* Using a card for individual team members */}
            <img src={co_founderPhoto} alt={t('about_us.cofounder_name_alt_text')} className="team-photo" />
            <p className="team-name">{t('about_us.cofounder_name')}</p>
            <p className="team-title">{t('about_us.cofounder_title')}</p>
          </div>
        </div>

        <div className="info-section"> {/* Renamed from right-column for better semantic meaning */}
          <div className="vision-section">
            <h2>{t('about_us.vision_title')}</h2>
            <p>{t('about_us.vision_description')}</p>
          </div>

          <div className="contact-section"> {/* Removed 'contact-info' as it's redundant with class name */}
            <h2>{t('about_us.contact_title')}</h2>
            <p>{t('about_us.office_address')}</p>
            <p>Email: <a href={`mailto:${t('about_us.email')}`}>{t('about_us.email')}</a></p> {/* Make email clickable */}
            <p>Phone: <a href={`tel:${t('about_us.phone_raw')}`}>{t('about_us.phone')}</a></p> {/* Make phone clickable, add raw phone for tel: link */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;